export const updateJewelryInquiry = (data) => ({
    type: 'UPDATE_JEWELRY_INQUIRY',
    data,
});